import { interfaces } from "inversify";
import { quizModule } from "@/arch/new_proposal/quizz/main/factory/QuizModule";
import { gatewayModule } from "@/arch/@core/main/factory/gateways/GatewayModule";

export const ContainerModules: interfaces.ContainerModule[] = [gatewayModule, quizModule];
